export interface BankDetails {
  bank_name: string;
  bank_account_name: string;
  bank_sort_code: string;
  bank_account_number: string;
}

export function parseBankDetails(raw: any): BankDetails {
  return {
    bank_name: String(raw?.bank_name || raw?.bankName || raw?.name || '').trim(),
    bank_account_name: String(raw?.bank_account_name || raw?.bankAccountName || '').trim(),
    bank_sort_code: String(raw?.bank_sort_code || raw?.bankSortCode || '').trim(),
    bank_account_number: String(raw?.bank_account_number || raw?.bankAccountNumber || '').trim(),
  };
}

export function normalizeBankDetails(bank: BankDetails, businessName?: string): BankDetails {
  const accountName = String(bank.bank_account_name || businessName || bank.bank_name || '').trim();
  return {
    bank_name: String(bank.bank_name || businessName || accountName || '').trim(),
    bank_account_name: accountName,
    bank_sort_code: String(bank.bank_sort_code || '').replace(/\D/g, ''),
    bank_account_number: String(bank.bank_account_number || '').replace(/\D/g, ''),
  };
}

export function formatSortCodeDisplay(sortCode: string): string {
  const digits = String(sortCode || '').replace(/\D/g, '');
  if (digits.length !== 6) return sortCode || '';
  return `${digits.slice(0, 2)}-${digits.slice(2, 4)}-${digits.slice(4, 6)}`;
}

export function hasCompleteBankDetails(bank?: Partial<BankDetails> | null): boolean {
  if (!bank) return false;
  const sortDigits = String(bank.bank_sort_code || '').replace(/\D/g, '');
  const accountDigits = String(bank.bank_account_number || '').replace(/\D/g, '');
  const accountName = String(bank.bank_account_name || bank.bank_name || '').trim();
  return !!(
    accountName &&
    sortDigits.length >= 6 &&
    accountDigits.length >= 6
  );
}
